<template>
   
       <div  class="row banner-component" role="alert" aria-live="assertive" aria-atomic="true">
           <div>
               <i class="bannner-icon fa-fw fas fa-exclamation-triangle d-inline-block" aria-hidden="true"></i>
           </div>
           <div class="banner-text col">
               <div v-html="bannerText"></div>       
           </div>
       </div>
   
</template>
   
   <script>
   
   import './msk.banner.scss';
   
   export default {
       name: 'msk-banner',
       props: {
           bannerText: { type: String }
       }
   };
   
   </script>